import React from 'react';
import CategoryPage from '../components/CategoryPage';

const MeetingRoomsPage = () => {
  return <CategoryPage categoryId="meeting-rooms" />;
};

export default MeetingRoomsPage;